<template>
  <div>
    <settings-card :config="config">
      <el-button
        type="text"
        @click="settings">去设置</el-button>
    </settings-card>
    <box-code-modal
      ref="box"
      :enable="enable" />
  </div>
</template>
<script>
import BoxCodeModal from './box-code-modal.vue'
import SettingsCard from './settings-card.vue'
export default {
  name: 'BrandCard',
  components: { SettingsCard, BoxCodeModal },
  props: {
    enable: { type: Boolean, default: true },
    config: { type: Object, default() { return {} } }
  },
  methods: {
    settings() {
      this.$refs.box.fetch()
    }
  }
}
</script>
